import _ from 'lodash';
import React from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import ReactTable, { Column } from 'react-table';
import { Dispatch } from 'redux';

import {
	ContextMenu,
	ContextMenuTrigger,
	MenuItem,
} from 'react-contextmenu';

import { fetchTable } from '../../redux/table/actions';
import { tablesSelector } from '../../redux/table/selectors';

import './index.scss';

const defaultLeft = 158;
const defaultTop = 178;

interface IMappedTableProps {
	getTable: (token: string) => void,
}

interface IMappedTableState {
	tables: any[],

}

interface IOwnTableProps {
	id: number
	parentRef: React.MutableRefObject<HTMLDivElement | null>
}

interface ITableColumnTypes extends Column<any> {
	title: string,
	show?: boolean
}

interface ITableColumnData extends Column {
	columns: ITableColumnTypes[]
}

type TableProps = IMappedTableProps & IMappedTableState & IOwnTableProps

interface ITableState {
	userPrefs: {
		modes: {
			buy: string[],
			sell: string[],
		},
	},
	tables: any[],
	columns: ITableColumnData[],
	menuItems: string[],
	checkItems: boolean[],
	offsetX: number,
	offsetY: number,
	token: string | null,
}


class TableComponent extends React.Component<TableProps, ITableState> {
	constructor(props: TableProps) {
		super(props);
		this.deleteColumnEventHandler = this.deleteColumnEventHandler.bind(this)
		this.addColumnEventHandler = this.addColumnEventHandler.bind(this)
		const columns: ITableColumnData[] = [
			{
				Header: () => <span className="header-time">Info</span>,
				columns: [
					{
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Market</span>
								<input type="checkbox" checked={true} data-first={0} data-second={0} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'market',
						title: 'Market',
						width: 120,
					},
					{
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1" data-first={0} data-second={1} onClick={this.deleteColumnEventHandler}>Instrument</span>
								<input type="checkbox" checked={true} data-first={0} data-second={1} onClick={this.deleteColumnEventHandler}/>
							</div>
						),
						accessor: 'model',
						title: 'Instrument',
						width: 135,
					},
				],
			},
			{
				Header: () => <span className="header-time">Indicators</span>,
				columns: [
					{
						Cell: ({ row }) => (
							<div
							style={{
								borderRadius: '2px',
								display: 'flex',
								fontWeight: 'bold',
								height: '100%',
								justifyContent: 'center',
								width: '100%',
							}}
							>
								<NumberFormat value={row.current} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
							</div>
						),
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Current</span>
								<input type="checkbox" checked={true} data-first={1} data-second={0} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'current',
						title: 'Current',
						width: 120,
					},
					{
						Cell: ({ row }) => {
							const diff = parseFloat(row.current) - parseFloat(row.previous_close);
							if (!Number.isNaN(parseFloat(row.current))) {
								return (
									<div
										style={{
                      borderRadius: '2px',
                      color: diff === 0 ? '#fff' : diff > 0 ? '#00C531' : '#ff0000',
                      display: 'flex',
                      fontWeight: 'bold',
                      height: '100%',
                      justifyContent: 'right',
                      width: '100%'
                    }}
									>
										<NumberFormat value={diff} prefix={diff > 0 ? '+' : ''} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
									</div>
								);
							}
							return '';
						},
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Chng.</span>
								<input type="checkbox" checked={true} data-first={1} data-second={1} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'previous_close',
						title: 'Chng.',
						width: 100,
					},
					{
						Cell: ({ row }) => {
							const diff = parseFloat(row.current) - parseFloat(row.previous_close);
							if (!Number.isNaN(parseFloat(row.current))) {
								return (
									<div
										style={{
                      borderRadius: '2px',
                      color: diff === 0 ? '#fff' : diff > 0 ? '#00C531' : '#ff0000',
                      display: 'flex',
                      fontWeight: 'bold',
                      height: '100%',
                      justifyContent: 'right',
                      width: '100%'
                    }}
									>
										{ diff > 0 ? '+' : '' } <NumberFormat value={100 * diff / parseFloat(row.previous_close)} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} /> { !Number.isNaN(row.current) ? '%' : '' } <span>&nbsp;</span>
									</div>
								);
							}
							return '';
						},
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Chng. Pct.</span>
								<input type="checkbox" checked={true} data-first={1} data-second={2} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'previous_close',
						title: 'Chng. Pct.',
						width: 140,
					},
					{
						Cell: row => {
							if (!Number.isNaN(row.value)) {
								return (
									<div className="d-flex justify-content-center">
										<NumberFormat value={row.value * 100} displayType="text" fixedDecimalScale={true} decimalScale={5} suffix="%" />
									</div>
								);
							}
							return <span>&nbsp;</span>;
						},
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Avg. RVOL</span>
								<input type="checkbox" checked={true} data-first={1} data-second={3} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'avg_rv',
						title: 'Avg. RVOL',
						width: 140,
					},
					{
						Cell: row => (
							<div className="d-flex justify-content-center">
								<NumberFormat value={row.value} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
							</div>
						),
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">10th</span>
								<input type="checkbox" checked={true} data-first={1} data-second={4} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'percentile10',
						title: '10th',
						width: 100,
					},
					{
						Cell: row => (
							<div className="d-flex justify-content-center">
								<NumberFormat value={row.value} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
							</div>
						),
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">90th</span>
								<input type="checkbox" checked={true} data-first={1} data-second={5} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'percentile90',
						title: '90th',
						width: 100,
					},
					{
						Cell: row => (
							<div className="d-flex justify-content-center">
								<NumberFormat value={row.value} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
							</div>
						),
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">TFTF 10th</span>
								<input type="checkbox" checked={true} data-first={1} data-second={6} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'tftf_10th',
						title: 'TFTF 10th',
						width: 135,
					},
					{
						Cell: row => (
							<div className="d-flex justify-content-center">
								<NumberFormat value={row.value} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
							</div>
						),
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">TFTF 90th</span>
								<input type="checkbox" checked={true} data-first={1} data-second={7} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'tftf_90th',
						title: 'TFTF 90th',
						width: 135,
					},
					{
						Cell: ({ row }) => {
							if (row._original.showRow !== 4 && row._original.showRow !== 9 && row._original.showRow !== 14) {
								return (
									<table className="cmatable" style={{ width: '100%', padding: '0px', fontSize: 'medium', borderLeft: 'solid gray 1px' }}>
										<tr style={{ borderBottom: 'gray solid 1px' }}>
												<td
													style={{
														backgroundColor: row.signal10.Cvalue === 'BUY' ? 'rgb(33, 136, 56)'
														: row.signal10.Cvalue === 'SELL' ? 'rgb(200, 35, 51)'
														: 'rgba(0, 0, 0, 0.0)',
														color: 'white',
														fontWeight: 'bold',
													}}
												>
													{row.signal10.Cvalue} &nbsp;
												</td>
										</tr>
										<tr style={{ borderBottom: 'gray solid 1px' }}>
											<td
													style={{
														backgroundColor: row.signal10.Mvalue === 'BUY' ? 'rgb(33, 136, 56)'
														: row.signal10.Mvalue === 'SELL' ? 'rgb(200, 35, 51)'
														: 'rgba(0, 0, 0, 0.0)',
														color: 'white',
														fontWeight: 'bold',
													}}
												>
													{row.signal10.Mvalue} &nbsp;
											</td>
										</tr>
										<tr>
											<td
													style={{
														backgroundColor: row.signal10.Avalue === 'BUY' ? 'rgb(33, 136, 56)'
														: row.signal10.Avalue === 'SELL' ? 'rgb(200, 35, 51)'
														: 'rgba(0, 0, 0, 0.0)',
														color: 'white',
														fontWeight: 'bold',
													}}
												>
													{row.signal10.Avalue} &nbsp;
											</td>
										</tr>
									</table>
								);
							}
							return '';
						},
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Sig. 10th</span>
								<input type="checkbox" checked={true} data-first={1} data-second={8} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'signal10',
						title: 'Sig. 10th',
						width: 130,
					},
					{
						Cell: ({ row }) => {
							if (row._original.showRow !== 4 && row._original.showRow !== 9 && row._original.showRow !== 14) {
								return (
									<table className="cmatable" style={{ width: '100%', padding: '0px', fontSize: 'medium', borderLeft: 'solid gray 1px' }}>
										<tr style={{ borderBottom: 'gray solid 1px' }}>
												<td
													style={{
														backgroundColor: row.signal90.Cvalue === 'BUY' ? 'rgb(33, 136, 56)'
														: row.signal90.Cvalue === 'SELL' ? 'rgb(200, 35, 51)'
														: 'rgba(0, 0, 0, 0.0)',
														color: 'white',
														fontWeight: 'bold',
													}}
												>
													{row.signal90.Cvalue} &nbsp;
												</td>
										</tr>
										<tr style={{ borderBottom: 'gray solid 1px' }}>
											<td
													style={{
														backgroundColor: row.signal90.Mvalue === 'BUY' ? 'rgb(33, 136, 56)'
														: row.signal90.Mvalue === 'SELL' ? 'rgb(200, 35, 51)'
														: 'rgba(0, 0, 0, 0.0)',
														color: 'white',
														fontWeight: 'bold',
													}}
												>
													{row.signal90.Mvalue} &nbsp;
											</td>
										</tr>
										<tr>
											<td
													style={{
														backgroundColor: row.signal90.Avalue === 'BUY' ? 'rgb(33, 136, 56)'
														: row.signal90.Avalue === 'SELL' ? 'rgb(200, 35, 51)'
														: 'rgba(0, 0, 0, 0.0)',
														color: 'white',
														fontWeight: 'bold',
													}}
												>
													{row.signal90.Avalue} &nbsp;
											</td>
										</tr>
									</table>
								);
							}
							return '';
						},
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Sig. 90th</span>
								<input type="checkbox" checked={true} data-first={1} data-second={9} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'signal90',
						title: 'Sig. 90th',
						width: 130,
					},
				],
			},
			{
				Header: () => <span className="header-time">Sell Predictions</span>,
				columns: [
					{
						Cell: ({ row }) => {
							const rowIndex = row._index;
							const mode = (this.state.userPrefs.modes !== undefined) ? this.state.userPrefs.modes.sell[rowIndex] : 'C';
							const classNames = {
								A: 'btn btn-secondary btn-mode-A',
								C: 'btn btn-secondary btn-mode-C',
								M: 'btn btn-secondary btn-mode-M',
							};

							classNames[mode] += ' active';

							if (row._original.showRow !== 4 && row._original.showRow !== 9 && row._original.showRow !== 14) {
								return (

									<table className="cmatable" style={{ width: '100%', padding: '0px', fontSize: 'medium', borderLeft: 'solid gray 1px' }}>
										<tr style={{ borderBottom: 'gray solid 1px' }}>
											<td style={{ color: '#007bff' }}>C</td>
												<td>
													<NumberFormat value={row.distance_sell_rally.Cpercentile10} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
												<td>
													<NumberFormat value={row.distance_sell_rally.Cpercentile90} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
										</tr>
										<tr style={{ borderBottom: 'gray solid 1px' }}>
											<td style={{ color: '#f0ad4e' }}>M</td>
												<td>
													<NumberFormat value={row.distance_sell_rally.Mpercentile10} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
												<td>
													<NumberFormat value={row.distance_sell_rally.Mpercentile90} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
										</tr>
										<tr>
											<td style={{ color: '#d9534f' }}>A</td>
												<td>
													<NumberFormat value={row.distance_sell_rally.Apercentile10} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
												<td>
													<NumberFormat value={row.distance_sell_rally.Apercentile90} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
										</tr>
									</table>
								);
							}
							return '';
						},
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Mode</span>
								<input type="checkbox" checked={true} data-first={2} data-second={0} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'distance_sell_rally',
						title: 'Sell_Mode',
						width: 250,
					},
				],
			},
			{
				Header: () => <span className="header-time">Buy Predictions</span>,
				columns: [
					{
						Cell: ({ row }) => {
							// const rowIndex = row._index;
							if (row._original.showRow !== 4 && row._original.showRow !== 9 && row._original.showRow !== 14) {
								return (
									<table className="cmatable" style={{ width: '100%', padding: '0px', fontSize: 'medium', borderLeft: 'solid gray 1px' }}>
										<tr style={{ borderBottom: 'gray solid 1px' }}>
											<td style={{ color: '#007bff' }}>C</td>
												<td>
													<NumberFormat value={row.distance_buy_dip.Cpercentile10} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
												<td>
													<NumberFormat value={row.distance_buy_dip.Cpercentile90} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
										</tr>
										<tr style={{ borderBottom: 'gray solid 1px' }}>
											<td style={{ color: '#f0ad4e' }}>M</td>
												<td>
													<NumberFormat value={row.distance_buy_dip.Mpercentile10} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
												<td>
													<NumberFormat value={row.distance_buy_dip.Mpercentile90} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
										</tr>
										<tr>
											<td style={{ color: '#d9534f' }}>A</td>
												<td>
													<NumberFormat value={row.distance_buy_dip.Apercentile10} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
												<td>
													<NumberFormat value={row.distance_buy_dip.Apercentile90} displayType="text" thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} />
												</td>
										</tr>
									</table>
								);
							}
							return '';
						},
						Header: () => (
							<div className="d-flex align-items-center justify-content-center">
								<span className="header-time p-1">Mode</span>
								<input type="checkbox" checked={true} data-first={3} data-second={8} onChange={this.deleteColumnEventHandler} />
							</div>
						),
						accessor: 'distance_buy_dip',
						title: 'Buy_Mode',
						width: 250,
					},
				],
			},
		];
		const menuItems: string[] = [];
		const checkItems: boolean[] = [];
		_.map(columns, column => {
			_.map(column.columns, item => {
				menuItems.push(item.title);
				if (item.show === undefined) {
					checkItems.push(true);
				} else {
					checkItems.push(item.show);
				}
			});
		});
		this.state = {
			checkItems,
			columns,
			menuItems,
			offsetX: 0,
			offsetY: 0,
			tables: [],
			token: localStorage.getItem('token'),
			userPrefs: {
				modes: {
					buy: ['C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C'],
					sell: ['C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C', 'C'],
				},
			},
		};
	}

	public componentDidMount() {
		if (this.state.token) {
			this.props.getTable(this.state.token);
			setTimeout(this.getOffset, 2000);
		}
	}

	public componentWillReceiveProps(nextProps: TableProps) {
		const {
			tables,
		} = this.props;
		if (nextProps.tables !== tables) {
			this.transformTableData(nextProps.tables);
		}
	}

	public getOffset = () => {
		if (this.props.parentRef.current && this.props.parentRef.current.parentElement && this.props.parentRef.current.parentElement.parentElement) {
			const tableDom = this.props.parentRef.current.parentElement.parentElement.parentElement;
			if (tableDom) {
				const domStyle = window.getComputedStyle(tableDom);
				const transform = domStyle.transform || domStyle.webkitTransform || (domStyle as any).mozTransform;
				const mat = transform.match(/^matrix\((.+)\)$/);
				if (mat) {
					this.setState({
						offsetX: parseFloat(mat[1].split(', ')[4]),
						offsetY: parseFloat(mat[1].split(', ')[5]),
					}, () => {
						const contextmenu = tableDom.getElementsByClassName('react-contextmenu')[0];
						if (contextmenu) {
							(contextmenu as any).style.transform = `translate(-${this.state.offsetX + defaultLeft}px, -${this.state.offsetY + defaultTop}px)`;
						}
					});
				}
			}
		}
	}

	// public handleChangeMode = (e) => {
	// 	const row = e.target.id.split('-');
	// 	const newModes = update(this.state.userPrefs.modes, {
	// 		[row[2]]: { [row[0]]: { $set: row[1] } },
	// 	});
	// 	const userPrefs = { ...this.state.userPrefs };
	// 	userPrefs.modes = newModes;
	// 	this.setState({ userPrefs }, () => {
	// 		// this.transformTableData(this.state.tables);
	// 	});
	// }

	public transformTableData = (tables: any[]) => {
		const self = this;
		const data = tables.slice();
		data.push({ model: String.fromCharCode(160), showRow: 4, stmomo: 100 });
		data.push({ model: String.fromCharCode(160), showRow: 9, stmomo: 100 });
		data.push({ model: String.fromCharCode(160), showRow: 14, stmomo: 100 });
		data.sort((a, b) => (a.showRow - b.showRow));
		if (data.length > 0) {
			const retArray = new Array(data.length).fill(null);
			_.each(data, (d, rowIndex) => {

				if (Object.prototype.hasOwnProperty.call(self.state.userPrefs, 'modes')) {
					let thresh10CSell = null;
					let thresh90CSell = null;
					let thresh10CBuy = null;
					let thresh90CBuy = null;

					let thresh10MSell = null;
					let thresh90MSell = null;
					let thresh10MBuy = null;
					let thresh90MBuy = null;

					let thresh10ASell = null;
					let thresh90ASell = null;
					let thresh10ABuy = null;
					let thresh90ABuy = null;

					// const modeCodeSell = self.state.userPrefs.modes.sell[rowIndex];
					// const modeCodeBuy = self.state.userPrefs.modes.buy[rowIndex];

					// Aggressive mode thresholds same all instruments
					[thresh10ASell, thresh90ASell] = [-12, 2];
					[thresh10ABuy, thresh90ABuy] = [2, -12];

					// Temporary change the daily model name
					if (typeof d.model !== 'undefined') {
						d.model = d.model.replace('1440min', 'Daily');
					}

					switch (d.model) {
					case 'ES 1min':
						[thresh10CSell, thresh90CSell] = [-29.43, 15.5];
						[thresh10MSell, thresh90MSell] = [-20.7, 8.75];

						[thresh10CBuy, thresh90CBuy] = [15.4, -28.7];
						[thresh10MBuy, thresh90MBuy] = [8.7, -15.35];

						break;
					case 'ES 5min':
						[thresh10CSell, thresh90CSell] = [-34.75, 15];
						[thresh10MSell, thresh90MSell] = [-23.4, 8.5];

						[thresh10CBuy, thresh90CBuy] = [15.6, -33.85];
						[thresh10MBuy, thresh90MBuy] = [8.8, -23];

						break;
					case 'ES 60min':
						[thresh10CSell, thresh90CSell] = [-15, 3];
						[thresh10MSell, thresh90MSell] = [-13.5, 2.5];

						[thresh10CBuy, thresh90CBuy] = [3, -15];
						[thresh10MBuy, thresh90MBuy] = [2.5, -13.5];

						break;
					case 'ES Daily':
						[thresh10CSell, thresh90CSell] = [-17, 4.3];
						[thresh10MSell, thresh90MSell] = [-14.5, 3.15];

						[thresh10CBuy, thresh90CBuy] = [4.8, -13.8];
						[thresh10MBuy, thresh90MBuy] = [3.4, -12.9];

						break;
					case 'NQ 1min':
						[thresh10CSell, thresh90CSell] = [-28.9, 14.46];
						[thresh10MSell, thresh90MSell] = [-20.45, 8.48];

						[thresh10CBuy, thresh90CBuy] = [15.93, -28.47];
						[thresh10MBuy, thresh90MBuy] = [8.97, -20.24];

						break;
					case 'NQ 5min':
						[thresh10CSell, thresh90CSell] = [-33.16, 14];
						[thresh10MSell, thresh90MSell] = [-22.58, 8];

						[thresh10CBuy, thresh90CBuy] = [15.3, -31.8];
						[thresh10MBuy, thresh90MBuy] = [8.65, -21.9];

						break;
					case 'NQ 60min':
						[thresh10CSell, thresh90CSell] = [-15, 3];
						[thresh10MSell, thresh90MSell] = [-13.5, 2.5];

						[thresh10CBuy, thresh90CBuy] = [3, -15];
						[thresh10MBuy, thresh90MBuy] = [2.5, -13.5];

						break;
					case 'NQ Daily':
						[thresh10CSell, thresh90CSell] = [-18.2, 4.3];
						[thresh10MSell, thresh90MSell] = [-15.1, 3.15];

						[thresh10CBuy, thresh90CBuy] = [4.6, -13.6];
						[thresh10MBuy, thresh90MBuy] = [3.3, -12.8];

						break;
					case 'SPX 1min':
						[thresh10CSell, thresh90CSell] = [-30, 16];
						[thresh10MSell, thresh90MSell] = [-21, 9];

						[thresh10CBuy, thresh90CBuy] = [16.75, -28.14];
						[thresh10MBuy, thresh90MBuy] = [9.38, -20.07];

						break;
					case 'SPX 5min':
						[thresh10CSell, thresh90CSell] = [-33.5, 14.95];
						[thresh10MSell, thresh90MSell] = [-22.75, 8.48];

						[thresh10CBuy, thresh90CBuy] = [15.41, -28.33];
						[thresh10MBuy, thresh90MBuy] = [8.71, -20.17];

						break;
					case 'SPX 60min':
						[thresh10CSell, thresh90CSell] = [-15, 3];
						[thresh10MSell, thresh90MSell] = [-13.5, 2.5];

						[thresh10CBuy, thresh90CBuy] = [3, -15];
						[thresh10MBuy, thresh90MBuy] = [2.5, -13.5];

						break;
					case 'SPX Daily':
						[thresh10CSell, thresh90CSell] = [-18.1, 3.8];
						[thresh10MSell, thresh90MSell] = [-15.05, 2.9];

						[thresh10CBuy, thresh90CBuy] = [4.23, -11.33];
						[thresh10MBuy, thresh90MBuy] = [3.12, -11.67];

						break;
					case 'NDX 1min':
						[thresh10CSell, thresh90CSell] = [-28.9, 14.46];
						[thresh10MSell, thresh90MSell] = [-20.45, 8.48];

						[thresh10CBuy, thresh90CBuy] = [15.93, -28.47];
						[thresh10MBuy, thresh90MBuy] = [8.97, -20.24];

						break;
					case 'NDX 5min':
						[thresh10CSell, thresh90CSell] = [-33.16, 14];
						[thresh10MSell, thresh90MSell] = [-22.58, 8];

						[thresh10CBuy, thresh90CBuy] = [15.3, -31.8];
						[thresh10MBuy, thresh90MBuy] = [8.65, -21.9];

						break;
					case 'NDX 60min':
						[thresh10CSell, thresh90CSell] = [-15, 3];
						[thresh10MSell, thresh90MSell] = [-13.5, 2.5];

						[thresh10CBuy, thresh90CBuy] = [3, -15];
						[thresh10MBuy, thresh90MBuy] = [2.5, -13.5];

						break;
					case 'NDX Daily':
						[thresh10CSell, thresh90CSell] = [-18.05, 4.4];
						[thresh10MSell, thresh90MSell] = [-15.03, 3.2];

						[thresh10CBuy, thresh90CBuy] = [4.2, -12.9];
						[thresh10MBuy, thresh90MBuy] = [3.1, -12.45];

						break;
					default:

						break;
					}

					d.signal10 = {};
					d.signal90 = {};

					d.signal10.Cvalue = (thresh10CSell !== null && d.tftf_10th < thresh10CSell) ? 'SELL' : '';
					d.signal10.Mvalue = (thresh10MSell !== null && d.tftf_10th < thresh10MSell) ? 'SELL' : '';
					d.signal10.Avalue = (thresh10ASell !== null && d.tftf_10th < thresh10ASell) ? 'SELL' : '';

					d.signal90.Cvalue = (thresh90CSell !== null && d.tftf_90th > thresh90CSell) ? 'SELL' : '';
					d.signal90.Mvalue = (thresh90MSell !== null && d.tftf_90th > thresh90MSell) ? 'SELL' : '';
					d.signal90.Avalue = (thresh90ASell !== null && d.tftf_90th > thresh90ASell) ? 'SELL' : '';

					d.signal10.Cvalue = (thresh10CBuy !== null && d.tftf_10th > thresh10CBuy) ? 'BUY' : d.signal10.Cvalue;
					d.signal10.Mvalue = (thresh10MBuy !== null && d.tftf_10th > thresh10MBuy) ? 'BUY' : d.signal10.Mvalue;
					d.signal10.Avalue = (thresh10ABuy !== null && d.tftf_10th > thresh10ABuy) ? 'BUY' : d.signal10.Avalue;

					d.signal90.Cvalue = (thresh90CBuy !== null && d.tftf_90th < thresh90CBuy) ? 'BUY' : d.signal90.Cvalue;
					d.signal90.Mvalue = (thresh90MBuy !== null && d.tftf_90th < thresh90MBuy) ? 'BUY' : d.signal90.Mvalue;
					d.signal90.Avalue = (thresh90ABuy !== null && d.tftf_90th < thresh90ABuy) ? 'BUY' : d.signal90.Avalue;

					const scaleTerm = (d.model.split(' ')[1] === '60min') ? 0.002 : 0.0001;

					d.distance_sell_rally = {};
					d.distance_buy_dip = {};

					// Sell Predictions
					if (thresh10CSell && thresh10MSell) {
						d.distance_sell_rally.Cpercentile10 = d.percentile10 * (1 - thresh10CSell * Math.max(d.avg_rv, scaleTerm)) || ' ';
						d.distance_sell_rally.Mpercentile10 = d.percentile10 * (1 - thresh10MSell * Math.max(d.avg_rv, scaleTerm)) || ' ';
						d.distance_sell_rally.Apercentile10 = d.percentile10 * (1 - thresh10ASell * Math.max(d.avg_rv, scaleTerm)) || ' ';
					}

					if (thresh90CSell && thresh90MSell) {
						d.distance_sell_rally.Cpercentile90 = d.percentile90 * (1 + thresh90CSell * Math.max(d.avg_rv, scaleTerm)) || ' ';
						d.distance_sell_rally.Mpercentile90 = d.percentile90 * (1 + thresh90MSell * Math.max(d.avg_rv, scaleTerm)) || ' ';
						d.distance_sell_rally.Apercentile90 = d.percentile90 * (1 + thresh90ASell * Math.max(d.avg_rv, scaleTerm)) || ' ';
					}
					// Buy Predictions
					if (thresh10CBuy && thresh10MBuy) {
						d.distance_buy_dip.Cpercentile10 = d.percentile10 * (1 - thresh10CBuy * Math.max(d.avg_rv, scaleTerm)) || ' ';
						d.distance_buy_dip.Mpercentile10 = d.percentile10 * (1 - thresh10MBuy * Math.max(d.avg_rv, scaleTerm)) || ' ';
						d.distance_buy_dip.Apercentile10 = d.percentile10 * (1 - thresh10ABuy * Math.max(d.avg_rv, scaleTerm)) || ' ';
					}

					if (thresh90CBuy && thresh90MBuy) {
						d.distance_buy_dip.Cpercentile90 = d.percentile90 * (1 + thresh90CBuy * Math.max(d.avg_rv, scaleTerm)) || ' ';
						d.distance_buy_dip.Mpercentile90 = d.percentile90 * (1 + thresh90MBuy * Math.max(d.avg_rv, scaleTerm)) || ' ';
						d.distance_buy_dip.Apercentile90 = d.percentile90 * (1 + thresh90ABuy * Math.max(d.avg_rv, scaleTerm)) || ' ';
					}
				}
				retArray[rowIndex] = d;
			});
			this.setState({ tables: retArray });
		}
	}

	public deleteColumnEventHandler = (e: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLSpanElement>) => {
		if (e.currentTarget.dataset.first && e.currentTarget.dataset.second) {
			this.handleColumnDelete(Number(e.currentTarget.dataset.first), Number(e.currentTarget.dataset.second))
		}
	}

	public handleColumnDelete = (first: number, second: number) => {
		const columns = this.state.columns.slice();
		if (columns[first].columns[second].show === undefined) {
			columns[first].columns[second].show = false;
		} else {
			columns[first].columns[second].show = !columns[first].columns[second].show;
		}
		const checkItems: boolean[] = [];
		_.map(columns, column => {
			_.map(column.columns, item => {
				if (item.show === undefined) {
					checkItems.push(true);
				} else {
					checkItems.push(item.show);
				}
			});
		});
		this.setState({ columns, checkItems });
	}

	public addColumnEventHandler = (e: React.MouseEvent<HTMLSpanElement>) => {
		if (e.currentTarget.dataset.title && e.currentTarget.dataset.index) {
			this.handleColumnAdd(e.currentTarget.dataset.title, Number(e.currentTarget.dataset.index))
		}
	}

	public handleColumnAdd = (title: string, index: number) => {
		const columns = this.state.columns.slice();
		const checkItems = this.state.checkItems.slice();
		checkItems[index] = !checkItems[index];
		_.map(columns, column => {
			_.map(column.columns, item => {
				if (item.title === title) {
					if (item.show === undefined) {
						item.show = false;
					} else {
						item.show = !item.show;
					}
				}
			});
		});
		this.setState({ columns, checkItems });
	}

	public render() {
		const { menuItems, tables, columns, checkItems } = this.state;

		return (
			<div>
				<ContextMenuTrigger id="table-context-menu">
					<ReactTable
						data={tables}
						showPagination={false}
						defaultPageSize={19}
						className="-striped -highlight"
						sorted={[{
							desc: false,
							id: 'showRow',
						}]}
						columns={columns}
						// SubComponent={(closeExpanded) => <div style={{ padding: '10px' }}>Hello</div>}
						// expanded={{ 0: true, 1: true }}
					/>
				</ContextMenuTrigger>
				<ContextMenu id="table-context-menu">
					{menuItems.map((mItem, index) => (
						<MenuItem key={index} data-title={mItem} data-index={index} onClick={this.addColumnEventHandler} data={{ menu: 1, item: 1 }}>
							<input type="checkbox" className="mr-2" checked={checkItems[index]} />
							{mItem}
						</MenuItem>))
					}
				</ContextMenu>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	tables: tablesSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getTable: (token: string) => dispatch(fetchTable(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableComponent);
